import { AppDispatch, Store } from 'store';
import getSearchFilters from 'store/search/selector/getSearchFilters';
import getCurrentResults from 'store/search/selector/getCurrentResults';
import getSearchQuery from 'store/search/selector/getSearchQuery';
import getSearchSession from 'store/search/selector/getSearchSessionId';
import getSearchSortBy from 'store/search/selector/getSearchSortBy';
import getHash from 'utils/getHash';
import getSearchStateForHash from 'store/search/selector/getSearchStateForHash';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmSearchResultsEvent from 'utils/gtm/gtmSearchResultsEvent';
import getOffset from 'store/search/selector/getOffset';

const gtmSendSearchResultsEventOperation = () => async (dispatch: AppDispatch, getState: () => Store) => {
  const store = getState();
  const results = getCurrentResults(store);
  const searchQuery = getSearchQuery(store);
  const searchFilters = getSearchFilters(store);
  const searchSessionId = getSearchSession(store);
  const searchResultsOffset = getOffset(store);
  const searchSortBy = getSearchSortBy(store);
  const { products } = results;
  const searchStateHash = await getHash(getSearchStateForHash(store));
  gtmSendEvent(
    gtmSearchResultsEvent(products, searchResultsOffset, {
      searchQuery,
      searchSessionId,
      searchFilters,
      searchSortBy,
      searchStateHash,
    }),
  );
};

export default gtmSendSearchResultsEventOperation;
